import React, {useState} from 'react';
import { AmplifyContainer } from '@aws-amplify/ui-react';
import {Container, Row, Col, Card, Form, Button, Spinner} from "react-bootstrap";
import esipLogo from "../../assets/e-SIP-logo.png";
import usernameIcon from '../../assets/login-username-icon.svg';
import passwordIcon from '../../assets/login-password-icon.svg';
import Alert from '../alert/alert';
import { cognitoSignIn, changeAuthState } from "../../helpr/authHelper";
import { AUTH_INVALID_USERNAME, AUTH_INVALID_PASSWORD } from "../../helpr/constants";
import { AuthState } from "@aws-amplify/ui-components";
import styles from './custom-login.module.scss';

import bgPath from '../../assets/login-bg-1.png';
import bgPath2 from '../../assets/login-bg-2.png';
import bgPath3 from '../../assets/login-bg-3.png';
import bgPath4 from '../../assets/login-bg-4.png';

const CustomLogin = () => {
  /*
    Initiate sign in form state
   */
  const [check, setCheck] = useState(false);
  const [signInState, setSignInState] = useState({onLogin:false})
  const [showErr, setShowErr] = useState({
    msg: '',
    type: 'alert-danger-custom',
    isVisible: false ,
    onClose: ()=>setShowErr({
      ...showErr,
      ['isVisible']: false
    })
  });
  /*
    Set sign in form on change of fields
   */
  const onChange = (e) => {
    const value = e.target.value;
    setSignInState({
      ...signInState,
      [e.target.id]: value
    });
  }

  /*
    Handle sign in event
   */
  const handleSignIn = async(e) => {
    e.preventDefault();
    setSignInState({
      ...signInState,
      onLogin: true
    });
    const { username, password} = signInState;

    try {
      /*
        Custom fields validation
       */
      if (!username) {
        throw new Error(AUTH_INVALID_USERNAME);
      }

      if (!password) {
        throw new Error(AUTH_INVALID_PASSWORD);
      }

      console.log("Signing in...");
      await cognitoSignIn(username.trim(), password);

    } catch (error) {
      console.log(error);
      if(error.code ===  'InvalidParameterException'){
        error.message = 'Username or password is incorrect.'
      }
      /*
        Display error message in UI
       */
      setShowErr({
        ...showErr,
        ['isVisible']: true,
        msg: 'Username or password is incorrect.',
        type: 'alert-danger-custom',
      });
      console.log('error loggin in:', error.message);
    } finally {
      setSignInState({
        ...signInState,
        onLogin: false
      });
    }
  }

  /*
    Handle forgot password
   */
  const handleForgotPassword = async () => {
    await changeAuthState(AuthState.ForgotPassword);
  }

  //Handle redirect to privacy notice
  const redirectToPrivacyNotice = () => {
    const newWindow = window.open(`${process.env.REACT_APP_CLIENT_ENDPOINT}/privacy-notice`, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }
  const redirectToTerms = () => {
    const newWindow = window.open(`${process.env.REACT_APP_CLIENT_ENDPOINT}/terms-conditions`, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }

  const renderLoginStatement = () => {
    return (
      <>
        By clicking {' '}<span className={styles['statement-bold']}>LOGIN</span>, I agree to the e-Securities Issue Portal
                    {' '}<span className={styles['statement-link']} onClick={() => redirectToTerms()}>Terms of Use</span>{' '}
                    and consent to the collection and use of my personal data as described in the
                    {' '}<span className={styles['statement-link']} onClick={() => redirectToPrivacyNotice()}>Privacy Notice</span>.
      </>
    )
  }


  return (
    <AmplifyContainer className={styles['custom-container']} slot='sign-in'>
      <div className={styles['static-background']}>
        <img className={styles['right-img']} src={bgPath3}/>
        <img className={styles['left-img']} src={bgPath}/>
        <img className={styles['top-left-img']} src={bgPath4}/>
        <div className={styles['Path']}></div>
        <img className={styles['bottom-left-img']} src={bgPath2}/>
        <img className={styles['logo']} alt="e-SIP" src={esipLogo}/>
      </div>
        <Row>
          <div className={styles['right-column']}>
            <Form className={styles['login-wrapper']} onSubmit={handleSignIn}>
              <div className={styles['header']}>
                Login
              </div>
              <Alert
                options={showErr}
              />
              <div className={styles['body']}>
                <Form.Group controlId="username">
                  <Form.Control
                    className={styles['text-input']}
                    aria-label="username"
                    type="text"
                    placeholder="Username"
                    onChange={onChange}/>
                </Form.Group>
                <Form.Group controlId="password">
                  <Form.Control
                    className={styles['text-input']}
                    aria-label="password"
                    type="password"
                    placeholder="Password"
                    onChange={onChange}/>
                </Form.Group>
                <div className={styles['forgot-pass']}>
                  <label><a href='#' onClick={handleForgotPassword}>Forgot Password?</a></label>
                </div>
                <div className={styles['login-statement']}>
                  <p>
                    <span><input type="checkbox" onChange={() => setCheck(!check)}/></span> {' '}
                    { renderLoginStatement() }
                  </p>
                </div>
                <div className={styles['action-btn']}>
                  <Button disabled={signInState.onLogin || !check} className={styles['login-button']} variant="primary" type="submit">
                    {signInState.onLogin ? <Spinner size="sm" animation="border"/> : 'LOGIN'}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Row>
    </AmplifyContainer>
  )
}

export default CustomLogin

